import styled from "styled-components";

export const OverFlowStyled = styled.div``;
